var exports = {
  "kx": "SetupBrandingPreview.module__hotspot___cHppM2",
  "mr": "SetupBrandingPreview.module__highlighted___cHppM2",
  "VH": "SetupBrandingPreview.module__preview___cHppM2",
  "xd": "SetupBrandingPreview.module__tabsScroller___cHppM2",
  "vR": "SetupBrandingPreview.module__tabs___cHppM2",
  "dw": "SetupBrandingPreview.module__stage___cHppM2",
  "JH": "SetupBrandingPreview.module__scene___cHppM2",
  "pG": "SetupBrandingPreview.module__caption___cHppM2",
  "zr": "SetupBrandingPreview.module__computerFrame___cHppM2",
  "Z": "SetupBrandingPreview.module__browserChrome___cHppM2",
  "nq": "SetupBrandingPreview.module__browserTabs___cHppM2",
  "Q0": "SetupBrandingPreview.module__browserTab___cHppM2",
  "Dm": "SetupBrandingPreview.module__favicon___cHppM2",
  "Ul": "SetupBrandingPreview.module__browserTabTitle___cHppM2",
  "aH": "SetupBrandingPreview.module__browserTabClose___cHppM2",
  "Ok": "SetupBrandingPreview.module__addressBar___cHppM2",
  "AI": "SetupBrandingPreview.module__addressIcon___cHppM2",
  "jq": "SetupBrandingPreview.module__computerPage___cHppM2",
  "k": "SetupBrandingPreview.module__pageBackground___cHppM2",
  "oP": "SetupBrandingPreview.module__backdropImage___cHppM2",
  "vo": "SetupBrandingPreview.module__backdropScrim___cHppM2",
  "J4": "SetupBrandingPreview.module__backdropScrimPhone___cHppM2",
  "Nr": "SetupBrandingPreview.module__card___cHppM2",
  "$Z": "SetupBrandingPreview.module__cardSplit___cHppM2",
  "cX": "SetupBrandingPreview.module__cardBrand___cHppM2",
  "N_": "SetupBrandingPreview.module__cardLogoBox___cHppM2",
  "kP": "SetupBrandingPreview.module__cardLogo___cHppM2",
  "vg": "SetupBrandingPreview.module__cardWordmarkBox___cHppM2",
  "kK": "SetupBrandingPreview.module__cardWordmark___cHppM2",
  "Kv": "SetupBrandingPreview.module__phoneWordmark___cHppM2",
  "V7": "SetupBrandingPreview.module__titlebarWordmark___cHppM2",
  "ly": "SetupBrandingPreview.module__cardHost___cHppM2",
  "VG": "SetupBrandingPreview.module__cardForm___cHppM2",
  "yu": "SetupBrandingPreview.module__formSkeleton___cHppM2",
  "Iz": "SetupBrandingPreview.module__skeletonTitle___cHppM2",
  "Ql": "SetupBrandingPreview.module__skeletonLine___cHppM2",
  "ES": "SetupBrandingPreview.module__skeletonInput___cHppM2",
  "G3": "SetupBrandingPreview.module__skeletonButton___cHppM2",
  "DV": "SetupBrandingPreview.module__skeletonButtonText___cHppM2",
  "cp": "SetupBrandingPreview.module__phoneFrame___cHppM2",
  "k0": "SetupBrandingPreview.module__phoneToolbar___cHppM2",
  "Hj": "SetupBrandingPreview.module__phoneAddress___cHppM2",
  "Un": "SetupBrandingPreview.module__phonePage___cHppM2",
  "qC": "SetupBrandingPreview.module__phoneContent___cHppM2",
  "$1": "SetupBrandingPreview.module__phoneIdentity___cHppM2",
  "JC": "SetupBrandingPreview.module__phoneLogoBox___cHppM2",
  "qO": "SetupBrandingPreview.module__phoneLogo___cHppM2",
  "bm": "SetupBrandingPreview.module__phoneWordmarkBox___cHppM2",
  "x_": "SetupBrandingPreview.module__phoneHost___cHppM2",
  "tG": "SetupBrandingPreview.module__desktopScene___cHppM2",
  "KF": "SetupBrandingPreview.module__windows___cHppM2",
  "Mf": "SetupBrandingPreview.module__titlebarLabel___cHppM2",
  "sy": "SetupBrandingPreview.module__platformTabs___cHppM2",
  "_B": "SetupBrandingPreview.module__titlebarFigure___cHppM2",
  "x": "SetupBrandingPreview.module__window___cHppM2",
  "fZ": "SetupBrandingPreview.module__windowDark___cHppM2",
  "bU": "SetupBrandingPreview.module__windowLight___cHppM2",
  "uL": "SetupBrandingPreview.module__titlebar___cHppM2",
  "pd": "SetupBrandingPreview.module__titlebarBrand___cHppM2",
  "XC": "SetupBrandingPreview.module__titlebarMacos___cHppM2",
  "MY": "SetupBrandingPreview.module__titlebarSpacer___cHppM2",
  "TM": "SetupBrandingPreview.module__trafficLights___cHppM2",
  "vu": "SetupBrandingPreview.module__windowControls___cHppM2",
  "JM": "SetupBrandingPreview.module__windowBody___cHppM2",
  "nP": "SetupBrandingPreview.module__windowRail___cHppM2",
  "$S": "SetupBrandingPreview.module__windowSidebar___cHppM2",
  "K6": "SetupBrandingPreview.module__windowMain___cHppM2",
  "V9": "SetupBrandingPreview.module__windowLine___cHppM2",
  "Xg": "SetupBrandingPreview.module__windowLineShort___cHppM2",
  "Ez": "SetupBrandingPreview.module__instanceStage___cHppM2",
  "y7": "SetupBrandingPreview.module__instanceRow___cHppM2",
  "Ub": "SetupBrandingPreview.module__instanceRowOther___cHppM2",
  "x$": "SetupBrandingPreview.module__instanceMark___cHppM2",
  "Dq": "SetupBrandingPreview.module__instanceMeta___cHppM2",
  "zl": "SetupBrandingPreview.module__instanceName___cHppM2",
  "Qh": "SetupBrandingPreview.module__instanceHost___cHppM2",
  "UC": "SetupBrandingPreview.module__instanceNameSkeleton___cHppM2",
  "ji": "SetupBrandingPreview.module__instanceHostSkeleton___cHppM2",
};

module.exports = exports;
